/**
 * Lifecycle states of an assistant conversation.
 * Keys equal values so entries can be used like a string enum.
 */
export const conversationStateTypes = {
  new: 'new',
  open: 'open',
  completed: 'completed',
  canceled: 'canceled',
  running: 'running',
  error: 'error',
} as const;

/** Union of all assistant conversation states. */
export type ConversationStateType =
  (typeof conversationStateTypes)[keyof typeof conversationStateTypes];

/**
 * Author role of a chat message in an assistant conversation.
 * Keys equal values so entries can be used like a string enum.
 */
export const messageTypes = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
} as const;

/** Union of all assistant message author roles. */
export type MessageType = (typeof messageTypes)[keyof typeof messageTypes];
